/**
 * On mouseup at screen coords, find the topmost DOM element with a
 * data-frame-id attribute, EXCLUDING the source frame. Returns the
 * target frame id, or null if drop landed on empty canvas.
 */
export function findDropTarget(clientX: number, clientY: number, sourceId: string): string | null {
  const stack = document.elementsFromPoint(clientX, clientY);
  for (const el of stack) {
    const id = (el as HTMLElement).getAttribute?.('data-frame-id');
    if (id && id !== sourceId) return id;
  }
  return null;
}

/** Generate short id for new frames + instances. */
export function shortId(): string {
  return Math.random().toString(36).slice(2, 9);
}
